import Image, {ImageProps, StaticImageData} from 'next/image'

export interface IIProps extends Omit<ImageProps, 'alt'>{
    src: string | StaticImageData;
    height?: SNN;
    noPriority?: boolean;
}

const I = (props: IIProps) => {
    let {
        src,
        height,
        width,
        priority = true,
        noPriority,
        ...other
    } = props
    if (noPriority) {
        priority = false
    }
    if (typeof src === 'string') {
        src = src.startsWith('http') ? src : `/book-content/img/${src}`
    }
    height = height || width

    return (
        <Image
            {...other}
            width={width}
            height={height}
            src={src}
            priority={priority}
            alt=''
        />
    )
}

export default I
